import {
    GetSubscribersArgs,
    AddSubscribersArgs,
    DeleteSubscriberArgs,
} from '~shared/schema/wiki/actions/page-subscribers';

import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';
import {i18n} from '~ui/components/SubscribeDialog/i18n';

import {makeSubscriberAddErrorHandler} from './utils';

const PAGE_SIZE = 50;

export const getSubscribers = createThunk(
    'subscribers/get',
    async ({pageId, paginationPageId}: GetSubscribersArgs, {extra: {sdk}}) => {
        return sdk.wiki
            .getPageSubscribers({
                pageId,
                pageSize: PAGE_SIZE,
                paginationPageId,
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'get-subscribers',
                    title: i18n('error-get-subscribers'),
                }),
            );
    },
);

export const addSubscribers = createThunk(
    'subscribers/add',
    async (
        {pageId, isCluster, users}: AddSubscribersArgs & {isCurrentUser: boolean},
        {extra: {sdk}},
    ) => {
        return (
            sdk.wiki
                .addPageSubscribers({
                    pageId,
                    isCluster,
                    users,
                })
                // TODO обработать все коды когда будут приходить с бека
                // Для более информативных ошибок
                .catch(makeSubscriberAddErrorHandler)
        );
    },
);

export const deleteSubscriber = createThunk(
    'subscribers/del',
    async (
        {pageId, subscriberId}: DeleteSubscriberArgs & {isCurrentUser: boolean},
        {extra: {sdk}},
    ) => {
        return sdk.wiki
            .deletePageSubscriber({
                pageId,
                subscriberId,
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'del-subscribers',
                    title: i18n('error-del-subscribers'),
                }),
            );
    },
);
